import { EmailRequest } from "./email-request";
import { IdentityDocumentRequest } from "./identity-document-request";

export class OtpCustomerRequest {
    firstName: string;
    email: EmailRequest[];
    identityDocument: IdentityDocumentRequest[];

    constructor(firstName?: string, email?: EmailRequest[],
        identityDocument?: IdentityDocumentRequest[]) {
        this.firstName = firstName ? firstName : '';
        this.email = email ? email : [];
        this.identityDocument = identityDocument ? identityDocument : [];
    }
}